export const TOUR_FINISHED = 'TOUR_FINISHED';
export const ALL_TOURS_FINISHED = 'ALL_TOURS_FINISHED';
export const GET_TOUR_STATE = 'GET_TOUR_STATE';
export const CLEAR_TOUR_STATES = 'CLEAR_TOUR_STATES';
